export enum PaymentType {
    Transfer = 'transfer',
    Loan = 'loanpayment',
    Wire = 'wire',
    ACH = 'ach',
    User = 'user',
}

export const paymentTypes = [
    PaymentType.Transfer,
    PaymentType.Loan,
    PaymentType.Wire,
    PaymentType.ACH,
    // PaymentType.User,
];
